import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    colors,
    DeleteOutlineIcon,
    MoreHorizIcon
} from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";
import Menu from "components/DesignComponents/Menu";
import NotificationsContext from "context/notifications/notificationsContext";
import { MenuAnchorEl } from "shared/types/types";

import { MoreActionsProps } from "./types";

const MoreActions = ({ id }: MoreActionsProps) => {
    const { textPlaceholder } = colors;

    const { deleteNotification } = useContext(NotificationsContext);

    const { t } = useTranslation();

    const [anchorEl, setAnchorEl] = useState<MenuAnchorEl>(null);

    const openMenu = (e: React.MouseEvent<SVGSVGElement>) =>
        setAnchorEl(e.currentTarget as unknown as MenuAnchorEl);

    const closeMenu = () => setAnchorEl(null);

    const removeNotification = () => {
        closeMenu();
        deleteNotification(id);
    };

    return (
        <>
            <MoreHorizIcon
                onClick={openMenu}
                css={css({
                    cursor: "pointer",
                    color: textPlaceholder,
                    marginTop: "4px"
                })}
            />

            <Menu
                open={Boolean(anchorEl)}
                onClose={closeMenu}
                anchorEl={anchorEl}
            >
                <ListChoice
                    title={t("Notifications##remove notification")}
                    iconLeft={<DeleteOutlineIcon />}
                    onClick={removeNotification}
                />
            </Menu>
        </>
    );
};

export default MoreActions;
